import { fetchAuthSession } from 'aws-amplify/auth';

export async function getAuthSession() {
  let session = await fetchAuthSession();
  if (!session?.tokens?.idToken) {
    session = await fetchAuthSession({ forceRefresh: true });
  }
  if (!session?.tokens?.idToken) {
    throw new Error('Your session has expired. Please sign in again.');
  }
  return session;
}

export function isSessionExpiredError(error) {
  const message = error?.message || error?.toString() || '';
  return message.includes('session has expired')
    || error?.name === 'NoIdentityId'
    || message.includes('NoIdentityId')
    || message.includes('idToken');
}
